import React from 'react';
import { ILocalizationProps } from 'framework/context/LocalizationProvider';
import { IStrings } from './IStrings';
import { LanguageOption } from 'gen/ApiClient';

export const SpecificLocalizationContext = React.createContext<ILocalizationProps<IStrings, LanguageOption>>(undefined as any);